import PropTypes from "prop-types";
import React, { useState } from "react";
import { Row, Col } from "react-flexbox-grid/lib/index";

import {
  TextField,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Button
} from "@material-ui/core";
import Search from "@material-ui/icons/Search";
import ShareIcon from "@material-ui/icons/Share";

const handleCopyButtonClick = () => {
  navigator.clipboard.writeText(window.location.href);
};

const SearchFiltersRow = props => {
  const [copyText, setCopyText] = useState("Copy URL");

  return (
    <div>
      <Row>
        <Col xs={9}>
          <Row>
            <Col xs={4}>
              <FormControl fullWidth>
                <InputLabel>Select Range</InputLabel>
                <Select
                  value={props.rangeFilter}
                  onChange={e => props.onRangeChange(e.target.value)}
                >
                  <MenuItem value="1 Days">1 Day</MenuItem>
                  <MenuItem value="1 Weeks">1 Week</MenuItem>
                  <MenuItem value="2 Weeks">2 Weeks</MenuItem>
                  <MenuItem value="1 Months">1 Month</MenuItem>
                  <MenuItem value="2 Months">2 Months</MenuItem>
                  <MenuItem value="3 Months">3 Months</MenuItem>
                  <MenuItem value="4 Months">4 Months</MenuItem>
                  <MenuItem value="5 Months">5 Months</MenuItem>
                  <MenuItem value="6 Months">6 Months</MenuItem>
                  <MenuItem value="7 Months">7 Months</MenuItem>
                  <MenuItem value="8 Months">8 Months</MenuItem>
                  <MenuItem value="9 Months">9 Months</MenuItem>
                  <MenuItem value="10 Months">10 Months</MenuItem>
                  <MenuItem value="11 Months">11 Months</MenuItem>
                  <MenuItem value="1 Years">1 Year</MenuItem>
                  <MenuItem value="2 Years">2 Years</MenuItem>
                  <MenuItem value="3 Years">3 Years</MenuItem>
                  <MenuItem value="4 Years">4 Years</MenuItem>
                  <MenuItem value="5 Years">5 Years</MenuItem>
                  <MenuItem value="100 Years">All history</MenuItem>
                </Select>
              </FormControl>
            </Col>

            <Col xs={4}>
              <FormControl fullWidth>
                <InputLabel>Error Class</InputLabel>
                <Select
                  value={props.errorFilter}
                  onChange={e => props.onErrorClassChange(e.target.value)}
                >
                  {props.submissionErrors.map(errors => {
                    return (
                      <MenuItem key={errors.hint} value={errors.hint}>
                        {errors.hint}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Col>
            <Col xs={4}>
              <TextField
                fullWidth
                value={props.serverSearchFilter}
                label="Search form data"
                type="search"
                onChange={e => props.onServerFilterChange(e.target.value)}
                onKeyPress={e => {
                  if (e.key === "Enter") {
                    props.onRefreshClick();
                  }
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col xs={5}>
              <TextField
                fullWidth
                type="search"
                value={props.searchFilter}
                label="Filter table"
                onChange={e => props.onFilterChange(e.target.value)}
              />
            </Col>
          </Row>
        </Col>
        <Col xs={2}>
          <Button
            color="secondary"
            variant="contained"
            style={{ marginTop: 25 }}
            fullWidth
            onClick={props.onRefreshClick}
          >
            Search
            <Search />
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              handleCopyButtonClick();
              setCopyText("Copied URL");
            }}
            style={{ marginTop: 25 }}
            fullWidth
          >
            {copyText}
            <ShareIcon />
          </Button>
        </Col>
      </Row>
    </div>
  );
};

SearchFiltersRow.propTypes = {
  serverSearchFilter: PropTypes.string.isRequired,
  onServerFilterChange: PropTypes.func.isRequired,
  onRefreshClick: PropTypes.func.isRequired,
  searchFilter: PropTypes.string.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onRangeChange: PropTypes.func.isRequired,
  onErrorClassChange: PropTypes.func.isRequired,
  errorFilter: PropTypes.string.isRequired,
  rangeFilter: PropTypes.string.isRequired,
  submissionErrors: PropTypes.arrayOf(
    PropTypes.shape({
      errors: PropTypes.string
    })
  )
};

SearchFiltersRow.defaultProps = {
  submissionErrors: []
};

export default SearchFiltersRow;
